export const genderOptions = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
]

export const relationshipOptions = [
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Spouse', label: 'Spouse' },
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Son', label: 'Son' },
  { value: 'Daughter', label: 'Daughter' },
]

export const maritalstatusOptions = [
  { value: 'Single', label: 'Single' },
  { value: 'Married', label: 'Married' },
  { value: 'Widowed', label: 'Widowed' },
  { value: 'Divorced', label: 'Divorced' },
]

export const bloodgroupOptions = [
  { value: 'A+', label: 'A RhD positive (A+)' },
  { value: 'A-', label: 'A RhD negative (A-)' },
  { value: 'B+', label: 'B RhD positive (B+)' },
  { value: 'B-', label: 'B RhD negative (B-)' },
  { value: 'O+', label: 'O RhD positive (O+)' },
  { value: 'O-', label: 'O RhD negative (O-)' },
  { value: 'AB+', label: 'AB RhD positive (AB+)' },
  { value: 'AB-', label: 'AB RhD negative (AB-)' },
]

export const religionstatusOptions = [
  {
    value: 'African Traditional &amp; Diasporic',
    label: 'African Traditional &amp; Diasporic',
  },
  { value: 'Agnostic', label: 'Agnostic' },
  { value: 'Atheist', label: 'Atheist' },
  { value: 'Buddhism', label: 'Buddhism' },
  { value: 'Cao Dai', label: 'Cao Dai' },
  {
    value: 'Chinese traditional religion',
    label: 'Chinese traditional religion',
  },
  { value: 'Christianity', label: 'Christianity' },
  { value: 'Hinduism', label: 'Hinduism' },
  { value: 'Islam', label: 'Islam' },
  { value: 'Jainism', label: 'Jainism' },
  { value: 'Juche', label: 'Juche' },
  { value: 'Judaism', label: 'Judaism' },
  { value: 'Neo-Paganism', label: 'Neo-Paganism' },
  { value: 'Nonreligious', label: 'Nonreligious' },
  { value: 'Rastafarianism', label: 'Rastafarianism' },
  { value: 'Secular', label: 'Secular' },
  { value: 'Shinto', label: 'Shinto' },
  { value: 'Sikhism', label: 'Sikhism' },
  { value: 'Spiritism', label: 'Spiritism' },
  { value: 'Tenrikyo', label: 'Tenrikyo' },
  { value: 'Zoroastrianism', label: 'Zoroastrianism' },
  { value: 'primal-indigenous', label: 'primal-indigenous' },
]

export const educationstatusOptions = [
  { value: 1, label: 'Educated' },
  { value: 0, label: 'Uneducated' },
]

export const priorexperienceOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
]

export const paidtypeOptions = [
  { value: 'Paid', label: 'Paid' },
  { value: 'Unpaid', label: 'Unpaid' },
]

export const leavetypeOptions = [
  { value: 'Sick', label: 'Sick' },
  { value: 'Casual', label: 'Casual' },
  { value: 'Annual', label: 'Annual' },
]

export const daytypeOptions = [
  { value: 'Full Day', label: 'Full Day' },
  { value: 'Half Day', label: 'Half Day' },
]

export const holidayOptions = [
  { value: 'Sunday', label: 'Sunday' },
  { value: 'Monday', label: 'Monday' },
  { value: 'Tuesday', label: 'Tuesday' },
  { value: 'Wednesday', label: 'Wednesday' },
  { value: 'Thursday', label: 'Thursday' },
  { value: 'Friday', label: 'Friday' },
  { value: 'Saturday', label: 'Saturday' },
]

export const ResignationTypeOptions = [
  { value: 'Resign', label: 'Resign' },
  { value: 'Terminate', label: 'Terminate' },
]

export const AccountTypeOptions = [
  { value: 'Sub Account', label: 'Sub Account' },
  { value: 'Parent Account', label: 'Parent Account' },
]

export const JobTypeOptions = [
  { value: 'Permanent', label: 'Permanent' },
  { value: 'Probation', label: 'Probation' },
  { value: 'Internee', label: 'Internee' },
]

export const EligibleforOvertimeOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
]

export const EmployeeAttendanceTypeOptions = [
  { value: 'Present', label: 'Present' },
  { value: 'Absent', label: 'Absent' },
  { value: 'Holiday', label: 'Holiday' },
  { value: 'leave', label: 'leave' },
  { value: 'Late Marked', label: 'late Marked' },
  { value: 'Attendance Missing', label: 'Attendance Missing' },
]

export const AttendanceDayTypeOptions = [
  { value: 'Sunday', label: 'Sunday' },
  { value: 'Monday', label: 'Monday' },
  { value: 'Tuesday', label: 'Tuesday' },
  { value: 'Wednesday', label: 'Wednesday' },
  { value: 'Thursday', label: 'Thursday' },
  { value: 'Friday', label: 'Friday' },
  { value: 'Saturday', label: 'Saturday' },
]

export const DayChangedOptions = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' },
]

export const IsDefaultOptions = [
  { value: 1, label: 'Yes' },
  { value: 2, label: 'No' },
]

export const QuestionsOptions = [
  { value: 5, label: 'Excellent Performance (5)' },
  { value: 4, label: 'Exceeds expectations (4)' },
  { value: 3, label: 'Meets Expectations (3)' },
  { value: 2, label: 'Needs Development (2)' },
  { value: 1, label: 'Unsatisfactory Performance (1)' },
]

export const RecommendedActionOptions = [
  { value: 'Successful completion', label: 'Successful completion' },
  { value: 'Termination of employment', label: 'Termination of employment' },
  { value: 'Extension of probationary period', label: 'Extension of probationary period' },
  { value: 'Demotion', label: 'Demotion' },
]

export const DsqOptions = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' },
]

export const FittedKitchenOptions = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' },
]

export const BackupGeneratorOptions = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' },
]

export const StatusOptions = [
  { value: 'For Sale', label: 'For Sale' },
  { value: 'For Rent', label: 'For Rent' },
  { value: 'Sold', label: 'Sold' },
  { value: 'Rented', label: 'Rented' },
  ]

export const VisibilityOptions = [
  { value: 'private', label: 'Private' },
  { value: 'password_protected', label: 'Password Protected' },
  { value: 'public', label: 'Public' },
]

// ===== New property form =====
export const PropertyTypeOptions = ['House/Villa', 'Apartment', 'Land', 'Commercial', 'Other']
export const ListingStatusNew = ['For Sale', 'For Rent']
export const ListingStatusAll = ['For Sale', 'For Rent', 'Sold', 'Rented']
export const CurrencyOptions = ['KES']
export const FurnishingOptions = ['Furnished', 'Semi-furnished', 'Unfurnished']
export const PlotUnitOptions = ['Acres', 'Hectares', 'Sq metres', 'Sq feet']
export const DefaultBills = ['Electricity', 'Water', 'Service charge']
export const DefaultFeatures = [
  'Fitted kitchen',
  'Backup generator',
  'DSQ',
  'Borehole',
  'Swimming pool',
  'Gym',
  'Garden',
  'Balcony',
  'Lift',
  '24h security',
  'CCTV',
]

